export interface McpWidgetSupportHost {
    isAvailable: () => boolean;
    createSessionId: () => string;
    openSupportPane: () => void;
    reportError: (reason: "availability" | "openSupportPane" | "postMessage") => void;
}

let registeredHost: McpWidgetSupportHost | undefined;

export function registerMcpWidgetSupportHost(host: McpWidgetSupportHost): void {
    registeredHost = host;
}

export function getMcpWidgetSupportHost(): McpWidgetSupportHost | undefined {
    return registeredHost;
}
